import { createContext } from 'react';

const openContext = createContext(false);

export default openContext;